import React, { useState, useEffect } from "react";

// import '../../styles/markdownStyle.css'

import Cookies from "js-cookie";
import { HashRouter as Router, Route, useHistory, Switch, Redirect, useLocation, Link } from "react-router-dom";
import { routes, subRoutes } from "@/router";

import { vistorRegister } from "../../api/apiAccount";

import { useDispatch } from "react-redux";
import { useAppSelector } from "@/hooks";
import { useTranslation } from "react-i18next";
import { checkAuthTokenValid } from "@/api/apiAccount";

import { AppDispatch } from "@/store";

import _ from "lodash";

import S_01 from "../../assets/bird/S_01.png";
import solgen from "../../assets/bird/solgen.png";
import S_04 from "../../assets/bird/s-04.png";
import S_04_a from "../../assets/bird/s-04a.png";
import S_03 from "../../assets/bird/S-03.png";
import S_03_a from "../../assets/bird/S-03a.png";
import platform from "../../assets/bird/platform.png";
import game from "../../assets/bird/game.png";
import zhuangshi_01 from "../../assets/bird/zhuangshi_01.png";
import icon_1 from "../../assets/bird/icon-1.png";
import icon_2 from "../../assets/bird/icon-2.png";
import icon_3 from "../../assets/bird/icon-3.png";
import icon_4 from "../../assets/bird/icon-4.png";
import icon_5 from "../../assets/bird/icon-5.png";
import logo from "../../assets/bird/logo.png";
import arrow from "../../assets/bird/arrow.png";
import r from "../../assets/bird/r.png";

// import required modules
export default function index() {
    const { t, i18n } = useTranslation();

    const showLoginPop = useAppSelector((state) => {
        return state.app && state.app.showLogin;
    });

    const [currentLanguage, setCurrentLanguage] = useState(i18n.language.substring(0, 2));

    const changeLanguage = () => {
        if (currentLanguage == "zh") {
            i18n.changeLanguage("en");
            setCurrentLanguage("en");
        } else if (i18n.language == "en") {
            i18n.changeLanguage("zh");
            setCurrentLanguage("zh");
        }
    };

    return (
        <div className="text-black w-full mx-auto max-w-[2560px]">
            {/* <div className="flex row py-5 lg:py-0 px-10 cursor-pointer" onClick={changeLanguage}>
                <img src={currentLanguage == "en" ? footer_lang_en : footer_lang_cn} alt="" />
                <span className="pl-3 text-lg font-bold text-black">
                    {t("home.footer.btn1")}
                    {t("generatedImage.dimensionsOfImage")}
                </span>
            </div> */}
            <div className="w-full mx-auto max-w-[1920px] text-[24px] flex  h-[80px] justify-between">
                <div className="flex items-center justify-start">
                    <img src={logo} alt="" className="h-[69px]" />
                    {/* <span className="ml-[147px] mr-[25px]">{t("home.dl")}</span> */}
                    {/* <img src={arrow} alt="" className="h-[13px]" /> */}
                </div>
                <div className="flex items-center">
                    {/* <span>{t("home.li")}</span> */}
                    {/* <img src={r} alt="" className="h-[56px]" /> */}
                    {/* <div className="ml-[67px] mr-[44px] w-[174px] h-[56px] bg-logup-bg leading-[56px] text-center text-white">
                        {t("home.lu")}
                    </div> */}
                    <div
                        onClick={changeLanguage}
                        className=" bg-[url('@/assets/bird/r1.png')] w-[114px] h-[58px] text-center leading-[58px]"
                    >
                        {currentLanguage == "en" ? "中文" : "EN"}
                    </div>
                </div>
            </div>
            <div className="pt-[174px] w-full max-w-[2560px] h-[1110px] bg-[url('@/assets/bird/bg_01.png')] bg-center">
                <img src={currentLanguage == "en" ? solgen : S_01} alt="" className="mx-auto mb-[170px]" />
                <div className="w-full flex h-[190px] justify-center">
                    <img src={icon_1} alt="" className="h-[190px]" />
                    <img src={icon_2} alt="" className="h-[190px]" />
                    <img src={icon_3} alt="" className="h-[190px]" />
                    <img src={icon_4} alt="" className="h-[190px]" />
                    <img src={icon_5} alt="" className="h-[190px]" />
                </div>
            </div>
            <div className="w-full max-w-[2560px] h-[602px]  -mt-[160px] flex  justify-center  items-center">
                <img src={zhuangshi_01} alt="" className="h-[411px]" />
                <div className="text-[28px] w-[1260px]  ml-[153px] font-bold">
                    <p className="mb-[40px] ">{t("home.p1")}</p>
                    <p className="mb-[40px]">{t("home.p2")}</p>
                    <p className="mb-[40px]">{t("home.p3")}</p>
                    <p>{t("home.p4")}</p>
                </div>
            </div>
            <img src={currentLanguage == "en" ? S_04_a : S_04} alt="" className="h-[123px] mx-auto" />
            <img src={game} alt="" className="h-[498px] mx-auto mt-[40px] mb-[57px]" />
            <img src={currentLanguage == "en" ? S_03_a : S_03} alt="" className="h-[127px] mx-auto " />
            <img src={platform} alt="" className="h-[599px] mx-auto mt-[40px]" />
            <div className="w-full max-w-[2560px] bg-[url('@/assets/bird/bg_02.png')] h-[578px] -mt-[302px] text-center pt-[441px] text-white text-[24px]">
                Hong Kong Gradient Descent Limited 香港梯度下降有限公司
            </div>
        </div>
    );
}
